import { Box, Flex } from '@chakra-ui/react'
import type { LoaderArgs } from '@remix-run/node'
import { json } from '@remix-run/node'
import { Outlet, useLoaderData } from '@remix-run/react'
import {
    hasPermissionForPlatform,
    isAllianceAdminForAtLeastOne,
    isCollabAdminForAtLeastOne,
    isPhnAdminForAtLeastOne,
} from '~/services/user/ensure-permissions.server'
import Footer from '../components/Footer'
import { Nav } from '../components/Nav'
import ScrollToTop from '../components/ScrollToTop'
import { getUserIfLoggedIn } from '../services/auth/auth.server'
import { submissionCreatable } from '../services/user/submissions.server'

export const loader = async ({ request }: LoaderArgs) => {
    const env = process.env.ENVIRONMENT ?? 'unknown'
    const user = await getUserIfLoggedIn(request)
    const canCreate = await submissionCreatable(user?.id ?? '')
    //if (!user) throw redirect('/login')

    let showAdmin = false
    if (user) {
        const isPlatformAdmin = hasPermissionForPlatform(user, 'Platform.AddAdmin')
        const isDhdaAdmin = hasPermissionForPlatform(user, 'DHDA.AddAdmin')
        const isAllianceAdmin = isAllianceAdminForAtLeastOne(user)
        const isPHNAdmin = isPhnAdminForAtLeastOne(user)
        const isCollabAdmin = isCollabAdminForAtLeastOne(user)

        showAdmin = isPlatformAdmin || isDhdaAdmin || isAllianceAdmin || isCollabAdmin || isPHNAdmin
    }

    return json({ user, env, canCreate, showAdmin })
}

export default function HomeLayout() {
    const { user, env, canCreate, showAdmin } = useLoaderData<typeof loader>()

    return (
        <Flex direction="column" height={'100%'}>
            <Nav user={user} canCreate={canCreate} showAdmin={showAdmin} env={env} />
            <Box id="scrollable-container" flex="1" overflowY="auto" px={6} ml={'auto'} mr={'2%'} width={'100%'}>
                <ScrollToTop />
                <Outlet />
            </Box>
            <Footer user={user} env={env} />
        </Flex>
    )
}
